/* eslint-disable import/no-mutable-exports */
import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import Cookies from 'js-cookie'
import { existThere } from '@/modules/route/redirect'
import { setItem } from '@/modules/storage/sessionStorage'
import { AWSRUMErrorCapture } from '@/utils/awsRumErrorCapture'
import { removeAuthParameters, getLocalUid } from '@/modules/zidAuth/localStorage'
import { logger } from './logger'

// eslint-disable-next-line import/no-mutable-exports
let api: NuxtAxiosInstance
export function initializeAxios(axiosInstance: NuxtAxiosInstance, redirect?: (path: string) => void): void {
  api = axiosInstance
  api.defaults.withCredentials = true

  api.onRequest(function (config: AxiosRequestConfig): AxiosRequestConfig {
    const localUid = getLocalUid()
    if (localUid) {
      config.headers['Local-Uid'] = localUid
    }

    if (
      process.env.NODE_BUILD_ENV === 'dev' ||
      process.env.NODE_BUILD_ENV === 'dev2' ||
      process.env.NODE_BUILD_ENV === 'dev3' ||
      process.env.NODE_BUILD_ENV === 'stg' ||
      process.env.NODE_BUILD_ENV === 'stg1' ||
      process.env.NODE_BUILD_ENV === 'stg2'
    ) {
      logger.debug('[on request]', {
        path: config.url,
        method: config.method,
        params: config.params,
        body: config.data,
      })
    }
    return config
  })

  api.onResponse(function (response: AxiosResponse): AxiosResponse {
    return response
  })

  // すべてのエラーが集約
  api.onError(function (error: AxiosError): void {
    AWSRUMErrorCapture.captureException(error)
    // 通常ログインおよび自動ログインのエラーはログイン画面でエラー表示を行うので除外
    logger.warning(error)

    // 401以外のエラーはトークン認証以外のエラーなので扱わない
    // LMSと違い403は発生しない為、401の確認のみで問題ない
    if (error.response?.status !== 401) {
      return
    }

    //
    // 401 認証エラーのときは、認証情報を削除してログイン画面へリダイレクトする
    //

    // 自動ログインを避けるためローカルストレージからLocal UIDとトークンと選択コース情報を削除
    removeAuthParameters()
    // cookieに格納されている会員番号を削除する
    // eslint-disable-next-line no-undef
    Cookies.remove('m_token', {
      path: process.env.COOKIE_PATH,
      domain: process.env.COOKIE_DOMAIN,
    })

    // 再ログインを促すメッセージをセットする（ログイン画面にリダイレクト後に表示される）
    const authErrorMessage =
      error.response?.data?.error?.messageId === 'MSG-LI-00015-E'
        ? error.response?.data?.error?.message
        : '再ログインが必要です'
    setItem('AUTH_ERROR_HAPPENED', authErrorMessage)

    // ログイン画面にいるときはNavigationDuplicatedエラーを避けるためにリダイレクトはしない
    if (redirect && !existThere(location.href, 'login')) {
      redirect('/login')
    }
  })

  // リクエストのエラー
  api.onRequestError(function (_: AxiosError): void {})

  // レスポンスのエラー
  api.onResponseError(function (_: AxiosError): void {})
}

export { api }
